import {
    ADMIN_GET_PREWORKS,
    ADMIN_ADD_PREWORKS,
    ADMIN_GET_PREWORKS_LIST,
    ADMIN_UPDATE_PREWORKS,
  } from '../constants/preworksConstant'


  export default function preworkReducer(state = { preworks: [] }, action) {
    switch (action.type) {
      case ADMIN_GET_PREWORKS_LIST: {
        return {
          preworks: action.payload,
        }
      }
      case ADMIN_ADD_PREWORKS: {
        let preworks = [...state.preworks]
        preworks.unshift(action.payload)
        return {
          ...state,
          preworks: preworks,
        }
      }
      case ADMIN_UPDATE_PREWORKS: {
        let preworks = [...state.preworks]
        let index = preworks.findIndex((prework) => prework._id === action.payload._id)
        preworks[index] = action.payload
        return {
          ...state,
          preworks: preworks,
        }
      }
      default: {
        return state
      }
    }
}